import { render, staticRenderFns } from "./ItemPdfEl.vue?vue&type=template&id=6b07156c&"
import script from "./ItemPdfEl.vue?vue&type=script&lang=ts&"
export * from "./ItemPdfEl.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports